import script from "./Pos.vue?vue&type=script&setup=true&lang=js"
export * from "./Pos.vue?vue&type=script&setup=true&lang=js"

import "./Pos.vue?vue&type=style&index=0&id=b9765380&scoped=true&lang=css"

import exportComponent from "E:\\_____LARAGON\\laragon\\www\\finalMatilda\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b9765380"]])

export default __exports__